import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import useRetellWidget from '../hooks/useRetellWidget';

const { FiFileText } = FiIcons;

const GetFreeEstimateButton = ({ 
  className = '', 
  variant = 'primary', 
  size = 'default', 
  children, 
  onClick,
  ...props 
}) => {
  const { openWidget } = useRetellWidget();

  // Define variant styles
  const getVariantStyles = () => {
    switch (variant) {
      case 'primary':
        return 'bg-blue-600 text-white hover:bg-blue-700 shadow-lg';
      case 'secondary':
        return 'bg-white text-blue-600 border-2 border-blue-600 hover:bg-blue-50 shadow-lg';
      case 'outline':
        return 'border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white';
      case 'ghost':
        return 'text-blue-600 hover:bg-blue-50';
      default:
        return 'bg-blue-600 text-white hover:bg-blue-700 shadow-lg';
    }
  };

  // Define size styles
  const getSizeStyles = () => {
    switch (size) {
      case 'small':
        return 'px-4 py-2 text-sm';
      case 'large':
        return 'px-8 py-4 text-lg';
      case 'xl':
        return 'px-10 py-5 text-xl';
      default:
        return 'px-6 py-3';
    }
  };

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    console.log("[GetFreeEstimateButton] Button clicked - opening Retell widget");
    
    // Call custom onClick if provided
    if (onClick) {
      onClick(e);
    }
    
    // Always try to open the widget
    openWidget();
  };

  const baseStyles = 'font-semibold rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2 cursor-pointer';
  const variantStyles = getVariantStyles();
  const sizeStyles = getSizeStyles();
  const combinedClassName = `${baseStyles} ${variantStyles} ${sizeStyles} ${className}`;

  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className={combinedClassName}
      onClick={handleClick}
      data-open-retell="true"
      data-retell-trigger="true"
      data-cta="estimate"
      name="get-free-estimate"
      aria-label="Get Free Estimate"
      {...props}
    >
      <SafeIcon icon={FiFileText} className="w-5 h-5" />
      <span>{children || 'Get Free Estimate'}</span>
    </motion.button>
  );
};

export default GetFreeEstimateButton;